class MainProduct extends HTMLElement {
  #currentVariant = null;

  constructor() {
    super();
    this.productId = this.dataset.productId;
    this.productUrl = this.dataset.productUrl;
    this.productHandle = this.dataset.productHandle;
    this.sectionId = this.dataset.sectionId;
  }

  connectedCallback() {
    this.#currentVariant = this.#resolveInitialVariant();
    this.addEventListener('variant:changed', this.#onVariantChanged);
  }

  disconnectedCallback() {
    this.removeEventListener('variant:changed', this.#onVariantChanged);
  }

  // Single source of truth for the selected variant: pickers read this instead of
  // each parsing the URL, so there is no shared-URL read/write race between them.
  get currentVariant() {
    return this.#currentVariant;
  }

  #resolveInitialVariant() {
    const node = this.querySelector('[data-variants-data]');
    if (!node) return null;
    let variants;
    try {
      variants = JSON.parse(node.textContent);
    } catch (err) {
      console.error('main-product: variants JSON parse failed', err);
      return null;
    }
    const urlId = parseInt(new URL(window.location.href).searchParams.get('variant'), 10);
    if (urlId) {
      const match = variants.find((v) => v.id === urlId);
      if (match) return match;
    }
    return variants.find((v) => v.available) || variants[0] || null;
  }

  #updateUrl(variantId) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', String(variantId));
    window.history.replaceState({}, '', url.toString());
  }

  #onVariantChanged = (event) => {
    const { variant, optionChanged } = event.detail || {};
    if (!variant) return;

    this.#currentVariant = variant;
    this.#updateUrl(variant.id);

    this.dispatchEvent(
      new CustomEvent('pdp:variant-update', {
        bubbles: false,
        detail: { variant, optionChanged }
      })
    );
  };
}

if (!customElements.get('main-product')) {
  customElements.define('main-product', MainProduct);
}
